"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ProductLayout_1 = __importDefault(require("./ProductLayout"));
var material_1 = require("@mui/material");
var backgroundImage = "https://images.unsplash.com/photo-1567016546367-c27a0d56712e?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80";
function LandingPage() {
    return (React.createElement(ProductLayout_1.default, { sxBackground: {
            backgroundImage: "url(".concat(backgroundImage, ")"),
            backgroundColor: "#7fc7d9",
            backgroundPosition: "center",
            minHeight: "92vh", // Set the height
        } },
        React.createElement("img", { style: { display: "none" }, src: backgroundImage, alt: "increase priority" }),
        React.createElement("div", { style: {
                display: "flex",
                alignItems: "flex-start",
                flexDirection: "column",
                marginRight: "60%",
            } },
            React.createElement(material_1.Typography, { color: "inherit", align: "left", variant: "h3", fontFamily: "Frank Ruhl Libre", sx: { mb: 4, mt: { xs: 4, sm: 10 } } },
                "Transform Your Space,",
                React.createElement("br", null),
                "One Piece At a Time"),
            React.createElement(material_1.Typography, { variant: "body2", color: "inherit", sx: { mb: 2, fontSize: "1.1rem" } }, "Discover the full experience of turning your home into a sanctuary with our carefully curated collection of our products."),
            React.createElement(material_1.Button, { color: "primary", variant: "contained", size: "large", component: "a", href: "#", sx: {
                    borderRadius: 20,
                    marginTop: 4,
                    padding: "15px 50px",
                } }, "SHOW NOW"))));
}
exports.default = LandingPage;
